export default "__VITE_ASSET__BcFDauPH__"